<template>
    <div class="float-left">
        <i class="fa fa-bars fa-lg icon-button ml-1 text-primary" title="Metas" @click.stop="abrirModal()">
        </i>
        <b-modal size="xl" v-model="mostrarModal" no-close-on-backdrop no-enforce-focus >
            <div slot="modal-title">Meta</div>
            <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Atendimento Previsto </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela :itens="metas" :campos="campos" :itensPorPagina="itensPorPagina"
                                    :bordered="false" :small="false">
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <btn-inserir-meta :evento="evento" :dataServicos="dataServicos"
                                                v-if="permiteInserirMetas && evento.statusId != 2 && acao.codSituacao != 1"
                                                @atualizarLista="obterMetas()">
                                            </btn-inserir-meta>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span class="text-secondary float-left mr-1" v-if="permiteCancelarMetas">
                                            <b-button-group class="float-right">
                                                <btn-cancelar-meta :evento="evento" :meta="data"
                                                    :dataServicos="dataServicos" @atualizarLista="obterMetas()"
                                                    @fecharModal="fecharModal()" @abrirModal="abrirModal()">
                                                </btn-cancelar-meta>
                                            </b-button-group>
                                        </span>
                                    </template>
                                    <template slot="situacao" slot-scope="data">
                                        <app-status :status="data.situacao.toUpperCase()"></app-status>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Atendimento Realizado </span>
                            </b-card-header>
                            <b-card-body>
                                <b-row>
                                    <b-col sm="24" md="6">
                                        <b-form-group>
                                            <label>Nome do Evento</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.nomeEvento" disabled>
                                                </b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Código do Evento</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.codEvento"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="18" md="4">
                                        <b-form-group>
                                            <label>Nome da Unidade</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.nomeUnidade"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Instrumento</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.instrumento"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Modalidade</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.modalidade"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Horas</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.horas"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label class="text-nowrap">Numero de Empresas Atendidas</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.numeroEmpresasAtendidas"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Numero de Pessoas Atendidas</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.numeroPessoasAtendidas"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                    <b-col sm="12" md="2">
                                        <b-form-group>
                                            <label>Data Final</label>
                                            <b-input-group>
                                                <b-form-input type="text" v-model="evento.dataFinalStr"
                                                    disabled></b-form-input>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>


                
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import BtnCancelarMeta from './BtnCancelarMeta'
import BtnInserirMeta from './BtnInserirMeta'

export default {
    components: {
        BtnInserirMeta,
        BtnCancelarMeta
    },

    props: {
        evento: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteInserirMetas: {
            type: Boolean,
            default: false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: false
        }
    },

    validations: {
        tipoInstrumento: {
            required
        }
    },

    data() {
        return {
            tipoInstrumento: null,
            quantidade: null,
            mostrarModal: false,
            erros: [],
            itensPorPagina: 5,
            metas: [],
            campos: [
                {
                    key: 'tipoInstrumentoDescricao',
                    label: 'Tipo Atendimento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'metaEmprAtendidas',
                    label: 'Empresas Atendidas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'metaPesAtendidas',
                    label: 'Pessoas Atendidas',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'cargoHoraria',
                    label: 'Cargo Horária',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ]
        }
    },

    methods: {
        abrirModal() {

            this.mostrarModal = true
            this.obterMetas()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        obterMetas() {
            this.$store.dispatch('addRequest')
            this.dataServicos
                .obterMetas(this.evento.idEvento)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.metas = response.data
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    }
}
</script>
